module.exports = __webpack_public_path__ + "static/media/palmsbackgroundWEB.abc03957.jpg";